<template>
  <div
    class="report-bd"
  >
    <div class="table-container">
      <div class="header">
        <div class="search-content">
          <el-form
            :inline="true"
            @submit.native.prevent
          >
            <el-radio-group
              v-model="formSearch.reportType"
              @change="onTypeChange"
            >
              <el-radio-button
                :label="item.value"
                v-for="(item, index) in reportTypeData"
                :key="index"
              >{{ item.label }}</el-radio-button>
            </el-radio-group>
            <el-form-item style="float: right; margin-right: 0">
              <custom-column ref="column"></custom-column>
            </el-form-item>
            <el-form-item
              style="float: right"
              v-if="funcView.runLog_location_export"
            >
              <el-button
                type="info"
                @click="onExport"
              >
                <i class="icon icon-export-excel"></i>
                {{ $t('Common.com_export') }}
              </el-button>
            </el-form-item>
            <el-form-item
              style="float: right"
              v-if="funcView.runLog_location_export&&formSearch.reportType === 3"
            >
              <el-button
                type="info"
                @click="onExportMonth"
              >
                <i class="icon icon-export-excel"></i>
                {{ $t('location_log.dao_chu_ming_xi') }}
              </el-button>
            </el-form-item>
            <el-form-item style="float: right">
              <i class="icon icon-shaixuan icon-filter" @click="isFilter = !isFilter"></i>
            </el-form-item>
            <el-form-item style="float: right">
              <search-input
                :placeholder="$t('Common.com_location_name')"
                v-model="formSearch.search"
                @fetch="onPageChange({ page: 1 })"
              ></search-input>
            </el-form-item>
            <el-form-item style="float: right">
              <div style="width: 380px;text-align: right;">
               <!-- 天 -->
                  <custom-date-picker
                    v-show="formSearch.reportType === 0"
                    v-model="dateTimes"
                    :init-value="initValue"
                    type="daterange"
                    align="right"
                    :clearable="false"
                    unlink-panels
                    value-format="YYYY-MM-DD HH:mm:ss"
                    @init="onTypeChange"
                    @change="onTypeChange"
                    :start-placeholder="$t('Common.com_start_date')"
                    :end-placeholder="$t('Common.com_end_date')"
                    :picker-options="pickerOptionsIntervalMonthReport"
                  ></custom-date-picker>
                  <!-- 历史报表 -->
                  <!-- 年 -->
                  <year-picker
                    v-show="formSearch.reportType === 1"
                    v-model="reportYearTime"
                    class="year-picker"
                    @change="onTypeChange"
                  ></year-picker>
                  <!-- 季度 -->
                  <season-picker
                    v-show="formSearch.reportType === 2"
                    v-model="reportSeasonTime"
                    ref="jidupicker"
                    class="season-picker"
                    @change="onTypeChange"
                  ></season-picker>
                  <!-- 月 -->
                  <el-date-picker
                    v-show="formSearch.reportType === 3"
                    v-model="reportMonthTime"
                    type="monthrange"
                    range-separator="—"
                    :format="$getElFormat('yyyy-MM', true)"
                    value-format="yyyy-MM"
                    align="right"
                    placeholder=""
                    :picker-options="pickerOptionsIntervalThreeYears"
                    :clearable="false"
                    @change="onTypeChange"
                    :start-placeholder="$t('Common.com_start_month')"
                    :end-placeholder="$t('Common.com_end_month')"
                  ></el-date-picker>
                  <!--周 -->
                  <week-picker
                    v-show="formSearch.reportType === 4"
                    v-model="reportWeekTime"
                    class="week-picker"
                    @change="onTypeChange"
                  ></week-picker>
                </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="query-filter" >
        <div class="params-form" v-show="isFilter">
          <el-row :gutter="23">

            <el-col :span="8">
              <div class="item">
                <div class="label">{{ $t('Common.com_belong_to_department') }}</div>
                <div class="value">
                  <custom-select
                    url="DepartmentTree"
                    v-model="formSearch.departmentId"
                    :model="formSearch"
                    :props="{ label: 'bizName', value: 'bizId',checkStrictly: true,map: { bizName: 'departmentName' } }"
                    :params="{ isCountDevice:1 }"
                    :placeholder="$t('Common.com_please_select')"
                    width="100%"
                    ref="tag"
                    type="tree"
                    filterable
                    :dataFilter="departmentTreeFilter"
                    @treeValChange="onPageChange({ page: 1 })"
                    @treeValChangeLabel="onDepartmentLabel"
                    @getList="onDepartmentList"
                    :clearable="false"
                  ></custom-select>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="filter-values">
          <div class="label">{{ $t('Common.com_filter_item') }}</div>
          <div class="values">
            <el-tag
              v-if="formSearch.bodyNum"
              closable
              @close="
                formSearch.bodyNum = '';
                onPageChange({ page: 1 });
              "
            >
              {{ formSearch.bodyNum }}
            </el-tag>
            <el-tag
              closable
              v-for="(productTag, index) in formSearch.productCode"
              :key="productTag"
              @close="clearTag('productCode', 'productName', index)"
            >{{ productTag }}</el-tag>
            <!-- 时间 -->
            <el-tag
              v-if="formSearch.reportType === 0 && formSearch.beginTime && formSearch.endTime"
              @close="
                dateTimes = [];
                initValue=[];
                onTypeChange();
              "
            >
              {{ momentAmPm($momentLocal(formSearch.beginTime)) }}-{{ momentAmPm($momentLocal(formSearch.endTime)) }}
            </el-tag>
            <el-tag
              v-if="formSearch.reportType === 4 && formSearch.beginTime && formSearch.endTime"
              @close="
                reportWeekTime = [];
                onTypeChange();
              "
            >
              {{ formSearch.beginTime }}-{{ formSearch.endTime }}
            </el-tag>
            <el-tag
              v-if="formSearch.reportType === 3 && formSearch.beginTime && formSearch.endTime"
              @close="
                reportMonthTime = [];
                onTypeChange();
              "
            >
              {{ formSearch.beginTime }}-{{ formSearch.endTime }}
            </el-tag>
            <el-tag
              v-if="formSearch.reportType === 2 && formSearch.beginTime && formSearch.endTime"
              @close="
                reportSeasonTime = [];
                onTypeChange();
              "
            >
              {{ formSearch.beginTime }}-{{ formSearch.endTime }}
            </el-tag>
            <el-tag
              v-if="formSearch.reportType === 1 && formSearch.beginTime && formSearch.endTime"
              @close="
                reportYearTime = [];
                onTypeChange();
              "
            >
              {{ formSearch.beginTime }}-{{ formSearch.endTime }}
            </el-tag>
            <el-tag
              v-if="formSearch.departmentId"
              closable
              @close="
                formSearch.departmentId = '';
                formSearch.departmentName = '';
                onPageChange({ page: 1 });
              "
            >
              {{ formSearch.departmentName }}
            </el-tag>
            <span
              class="clear"
              @click="onClear"
            >{{ $t('Common.com_clear') }}</span>
          </div>
        </div>
      </div>
    </div>
    <div style="border-radius: 16px; padding: 24px 24px 0; background: #fff;">
      <div class="table-bd">
        <!-- 美国站是ft² -->
        <custom-table
          v-if="formSearch.reportType === 0&&isUs"
          tableCode="portal_location_log_ft"
          :stripe="true"
          @column="setColumn"
          height="100%"
          :index="true"
          :data="tableList"
          @sort="sortChange"
          @filter="filterChange"
          :slots="['cleanScore','totalCleanArea', 'goalArea', 'avgCleanArea']"
          :filterArr="filterArr"
        >
          <!--
            cleanScore
            totalCleanArea
            goalArea
            avgCleanArea
          -->
          <template v-slot:cleanScore="scope">
            <span :style="getCleanScoreColor(scope.row.cleanScore)">{{scope.row.cleanScore}}</span>
          </template>
          <template v-slot:totalCleanArea="scope">
            <span>{{$formatLenLocal(scope.row.totalCleanArea)}}</span>
          </template>
          <template v-slot:goalArea="scope">
            <span>{{$formatLenLocal(scope.row.goalArea)}}</span>
          </template>
          <template v-slot:avgCleanArea="scope">
            <span>{{$formatLenLocal(scope.row.avgCleanArea)}}</span>
          </template>
        </custom-table>
        <custom-table
          v-if="formSearch.reportType === 0&&!isUs"
          tableCode="portal_location_log"
          :stripe="true"
          @column="setColumn"
          height="100%"
          :index="true"
          :data="tableList"
          @sort="sortChange"
          @filter="filterChange"
          :filterArr="filterArr"
          :slots="['cleanScore']"
        >
          <template v-slot:cleanScore="scope">
            <span :style="getCleanScoreColor(scope.row.cleanScore)">{{scope.row.cleanScore}}</span>
          </template>
        </custom-table>
        <!-- 美国站是ft² -->
        <custom-table
          v-if="formSearch.reportType !== 0&&isUs"
          tableCode="portal_location_log_date_ft"
          :stripe="true"
          @column="setColumn"
          height="100%"
          :index="true"
          :data="tableList"
          @sort="sortChange"
          @filter="filterChange"
          :slots="['totalCleanArea','avgCleanArea','actualCleanArea','attendanceRate']"
          :filterArr="filterArr"
        >
          <!--
            totalCleanArea
            avgCleanArea
            actualCleanArea
            attendanceRate
          -->
          <template v-slot:totalCleanArea="scope">
            <span>{{$formatLenLocal(scope.row.totalCleanArea)}}</span>
          </template>
          <template v-slot:avgCleanArea="scope">
            <span>{{$formatLenLocal(scope.row.avgCleanArea)}}</span>
          </template>
          <template v-slot:actualCleanArea="scope">
            <span>{{$formatLenLocal(scope.row.actualCleanArea)}}</span>
          </template>
          <template v-slot:attendanceRate="scope">
            <span :style="getCleanScoreColor(scope.row.attendanceRate)">{{scope.row.attendanceRate}}</span>
          </template>
        </custom-table>
        <custom-table
          v-if="formSearch.reportType !== 0&&!isUs"
          tableCode="portal_location_log_date"
          :stripe="true"
          @column="setColumn"
          height="100%"
          :index="true"
          :data="tableList"
          @sort="sortChange"
          @filter="filterChange"
          :slots="['attendanceRate']"
          :filterArr="filterArr"
        >
          <template v-slot:attendanceRate="scope">
            <span :style="getCleanScoreColor(scope.row.attendanceRate)">{{scope.row.attendanceRate}}</span>
          </template>
        </custom-table>
      </div>
      <div class="page-footer">
        <custom-pagination
          :radius="false"
          :total="totalRows"
          :page="formSearch.pageNum"
          :size="formSearch.pageSize"
          @change="onPageChange"
        ></custom-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import apis from '@/utils/apis';
import seasonPicker from '@/components/quarterlyRangePicker.vue';
import yearPicker from '@/components/yearRangePicker.vue';
import weekPicker from '@/components/weekRangePicker.vue';

export default {
  name: 'locationLog',
  components: {
    seasonPicker,
    yearPicker,
    weekPicker,
  },
  computed: {
    reportTypeData() {
      return [
        {
          label: this.$t('location_log.ri'),
          value: 0,
        },
        {
          label: this.$t('location_log.zhou'),
          value: 4,
        },
        {
          label: this.$t('location_log.yue'),
          value: 3,
        },
        {
          label: this.$t('location_log.ji'),
          value: 2,
        },
        {
          label: this.$t('location_log.nian'),
          value: 1,
        },
      ];
    },
    filterArr() {
      if (this.isCoJv) {
        return ['bigCustomerName'];
      }
      return ['customerName', 'bigCustomerName'];
    },
    orgId() {
      const userInfo = this.$store.state.userInfo;
      return userInfo ? userInfo.rootOrgId : '';
    }
  },
  data() {
    return {
      provide: true,
      formSearch: {
        reportType: 0,
        search: '',
        orderBy: '',
        orderType: '',
        pageSize: 50,
        pageNum: 1,

        bodyNum: '',
        productCode: '',
        productName: '',
        locationId: '',
        locationName: '',
        showSubsidiary: '',
        // region: '',
        locationAddress: '',
        afterServiceName: '',
        agentCoName: '',
        customerName: '',

        beginTime: '',
        endTime: '',
        countryCode: '',
        provinceCode: '',
        cityCode: '',
        country: '',
        province: '',
        city: '',
        departmentId: '',
        departmentName: ''
      },
      // 日
      initValue: '',
      dateTimes: '',
      reportYearTime: [`${moment(this.$getLocalTime()).year()}`, `${moment(this.$getLocalTime()).year()}`],
      reportSeasonTime: [`${new Date().getFullYear()}-${this.getSeason(new Date().getMonth())}`, `${new Date().getFullYear()}-${this.getSeason(new Date().getMonth())}`],
      reportMonthTime: [`${moment(this.$getLocalTime()).add('month').format('YYYY-MM')}`, `${moment(this.$getLocalTime()).add('month').format('YYYY-MM')}`],
      reportWeekTime: [this.$momentElLocal(moment().week(moment().week())), this.$momentElLocal(moment().week(moment().week()))],
      tableList: [],
      totalRows: 0,
      // 选择日期配置
      pickerOptionDisAfter: {
        shortcuts: [
          {
            text: this.$t('location_log.zui_jin_yi_zhou'),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: this.$t('location_log.zui_jin_yi_ge_yue'),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: this.$t('location_log.zui_jin_san_ge_yue'),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
        disabledDate: time => moment(time).isAfter(this.$getLocalTime(), 'day'),
      },
      pickerOptionsMonth: {
        firstDayOfWeek: 1,
        disabledDate: time => moment(time).isAfter(this.$getLocalTime(), 'day'),
      },
      isFilter: false,
    };
  },

  mounted: function () {
    this.initValue = [this.$moment(this.$getLocalTime()).subtract(1, 'day').format('YYYY-MM-DD 00:00:00'), this.$moment(this.$getLocalTime()).format('YYYY-MM-DD 23:59:59')];
    this.formSearch.beginTime = this.dateTimes ? this.dateTimes[0] : '';
    this.formSearch.endTime = this.dateTimes ? this.dateTimes[1] : '';
    // this.getTableList();
    this.getFuncView();
  },
  methods: {
    departmentTreeFilter(obj) {
      const ret = [obj];
      const ret2 = this.removeEmptyChildren(ret);
      return ret2;
    },
    removeEmptyChildren(nodes) {
      return nodes.map((item) => {
        // 如果 children 存在且是空数组，则删除 children 属性
        if (Array.isArray(item.children) && item.children.length === 0) {
          const newItem = { ...item }; // 创建一个新的对象，避免直接修改原数据
          delete newItem.children; // 删除 children 属性
          return newItem; // 返回没有 children 属性的对象
        }

        // 如果有子节点，递归调用 removeEmptyChildren
        if (item.children && item.children.length > 0) {
          return { ...item, children: this.removeEmptyChildren(item.children) };
        }

        return item; // 其他情况直接返回
      });
    },
    onDepartmentList(list) {
      this.departmentList = list;
    },
    onDepartmentLabel(Label) {
      this.formSearch.departmentName = Label;
    },
    // 获取列表
    getTableList() {
      // this.formSearch.beginTime = this.formSearch.dateTimes ? this.formSearch.dateTimes[0] : '';
      // this.formSearch.endTime = this.formSearch.dateTimes ? this.formSearch.dateTimes[1] : '';

      this.formSearch.showSubsidiary = this.showSubsidiary;
      if (this.formSearch.reportType === 0) {
        this.$getJSON(apis.ReportDailyLocationPage, { ...this.formSearch,
          orgId: this.orgId,
          isToday: 0,
          startDate: this.$momentElLocal(this.formSearch.beginTime, 'YYYY-MM-DD'),
          endDate: this.$momentElLocal(this.formSearch.endTime, 'YYYY-MM-DD'),
          departmentId: this.formSearch.departmentId ? this.formSearch.departmentId[this.formSearch.departmentId.length - 1] : '' })
          .then((res) => {
            const data = res.data.list;
            this.nullValueToCrossbar(data, ['assistCount', 'orderCharged', 'isMeetGoal', 'isAttendance']);
            this.tableList = data;
            this.totalRows = res.data.total;
          })
          .catch(() => {
            this.tableList = [];
          });
      } else {

        this.$getJSON(apis.LocationDevicePage, { ...this.formSearch,
          beginReportDate: this.formSearch.beginTime.replace(/-/g, ''),
          endReportDate: this.formSearch.endTime.replace(/-/g, ''),
          orgId: this.orgId,
          departmentId: this.formSearch.departmentId ? this.formSearch.departmentId[this.formSearch.departmentId.length - 1] : '' })
          .then((res) => {
            const data = res.data.list;
            this.nullValueToCrossbar(data, ['assistCount', 'orderCharged', 'isMeetGoal', 'isAttendance']);
            this.tableList = data;
            this.totalRows = res.data.total;
          })
          .catch(() => {
            this.tableList = [];
          });
      }
    },
    // 获取季度
    getSeason: function (month) {
      if (month < 3) {
        return '01';
      } else if (month < 6) {
        return '02';
      } else if (month < 9) {
        return '03';
      } else if (month < 12) {
        return '04';
      }
      return true;
    },
    onTypeChange() {
      switch (this.formSearch.reportType) {
        case 1:
          this.formSearch.beginTime = this.reportYearTime ? this.reportYearTime[0] : '';
          this.formSearch.endTime = this.reportYearTime ? this.reportYearTime[1] : '';
          this.onPageChange({ page: 1 });
          break;
        case 2:
          this.formSearch.beginTime = this.reportSeasonTime ? this.reportSeasonTime[0] : '';
          this.formSearch.endTime = this.reportSeasonTime ? this.reportSeasonTime[1] : '';
          this.onPageChange({ page: 1 });
          break;
        case 3:
          this.formSearch.beginTime = this.reportMonthTime ? this.reportMonthTime[0] : '';
          this.formSearch.endTime = this.reportMonthTime ? this.reportMonthTime[1] : '';
          this.onPageChange({ page: 1 });
          break;
        case 4:
          // 设置周的开始时间是星期一 1月1号是年开始的第一周
          moment.updateLocale('en', {
            week: {
              // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
              dow: 1, // Monday is the first day of the week.
              doy: 7, // The week that contains Jan 4th is the first week of the year.// 年份的第一周必须包含1月1日 (7 + 1 - 1)
            },
          });
          this.formSearch.beginTime = this.reportWeekTime.length ? moment(this.reportWeekTime[0]).format('gggg-ww') : ''; // 转换时间因为现在是Date类型
          this.formSearch.endTime = this.reportWeekTime.length ? moment(this.reportWeekTime[1]).format('gggg-ww') : ''; // 转换时间因为现在是Date类型
          this.onPageChange({ page: 1 });
          break;
        default:
          this.formSearch.beginTime = this.dateTimes.length ? this.dateTimes[0] : '';
          this.formSearch.endTime = this.dateTimes.length ? this.dateTimes[1] : '';
          this.onPageChange({ page: 1 });
      }
    },
    clearTag(key, name, index) {
      this.formSearch[key].splice(index, 1);
      this.formSearch[name].splice(index, 1);
      this.onPageChange({ page: 1 });
    },
    onClear() {
      this.formSearch.bodyNum = '';
      this.formSearch.productCode = '';
      this.formSearch.productName = '';
      this.formSearch.locationName = '';
      this.formSearch.locationId = '';
      this.formSearch.region = '';
      this.formSearch.locationAddress = '';
      this.formSearch.afterServiceName = '';
      this.formSearch.agentCoName = '';
      // this.formSearch.beginTime = '';
      // this.formSearch.endTime = '';
      this.formSearch.countryCode = '';
      this.formSearch.provinceCode = '';
      this.formSearch.cityCode = '';

      this.formSearch.tagName = '';
      // this.dateTimes = [];
      // this.initValue = [this.$moment().subtract(1, 'day').format('YYYY-MM-DD 00:00:00'), this.$moment().format('YYYY-MM-DD 23:59:59')];
      // this.initValue = [];
      // this.reportYearTime = [];
      // this.reportSeasonTime = [];
      // this.reportMonthTime = [];
      // this.reportWeekTime = [];
      this.formSearch.departmentId = '';
      this.formSearch.departmentName = '';
      // initValue会调用到
      // this.onPageChange({ page: 1 });
    },
    getCleanScoreColor(rate) {
    // 提取百分比值中的数字部分
      const value = parseFloat(rate);
      if (typeof value !== 'number') {
        return {};
      }
      // 根据条件返回不同的颜色样式
      if (value >= 90) {
        return { color: '#4CAF50' }; // 绿色
      } else if (value >= 70 && value < 90) {
        return { color: '#FFC107' }; // 黄色
      } else {
        return { color: '#F44336' }; // 红色
      }
    },
    onExport: function () {
      this.formSearch.showSubsidiary = this.showSubsidiary;
      if (this.formSearch.reportType === 0) {
        this.exportTable('ReportDailyLocationExport', { ...this.formSearch,
          orgId: this.orgId,
          isToday: 0,
          startDate: this.$momentElLocal(this.formSearch.beginTime, 'YYYY-MM-DD'),
          endDate: this.$momentElLocal(this.formSearch.endTime, 'YYYY-MM-DD'),
          platform: 'portal',
          departmentId: this.formSearch.departmentId ? this.formSearch.departmentId[this.formSearch.departmentId.length - 1] : '',
          excludeColumnList: this.filterArr
        });
      } else {
        this.exportTable('LocationDeviceExport', { ...this.formSearch,
          beginReportDate: this.formSearch.beginTime.replace(/-/g, ''),
          endReportDate: this.formSearch.endTime.replace(/-/g, ''),
          orgId: this.orgId,
          platform: 'portal',
          departmentId: this.formSearch.departmentId ? this.formSearch.departmentId[this.formSearch.departmentId.length - 1] : '',
          excludeColumnList: this.filterArr
        });
      }
    },
    onExportMonth() {
      this.exportTable('LocationDeviceMonthDetailExport', { ...this.formSearch,
        beginReportDate: this.formSearch.beginTime.replace(/-/g, ''),
        endReportDate: this.formSearch.endTime.replace(/-/g, ''),
        orgId: this.orgId,
        platform: 'portal',
        departmentId: this.formSearch.departmentId ? this.formSearch.departmentId[this.formSearch.departmentId.length - 1] : '',
        excludeColumnList: this.filterArr }).then(() => {
        this.exporting = false;
      }).catch(() => {
        this.exporting = false;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    dataFilterTree: function (list, code) {
      // 要过滤第一层 那children那层
      if (list.length > 0 && list[0].code === code) {
        const node = list[0];
        return node && node.children ? node.children : [];
      } else {
        return list;
      }
    },

  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';
.report-bd {
  .table-container {
    border-radius: 16px;
    background: #fff;
    width: 100%;

    padding: 24px;
    // padding-bottom: 0;
    .el-radio-button:first-child .el-radio-button__inner {
      border-radius: 20px 0 0 20px;
    }

    .el-radio-button:last-child .el-radio-button__inner {
      border-radius: 0 20px 20px 0;
    }
    .icon-filter {
      display: inline-block;
      text-align: center;
      box-sizing: border-box;
      font-size: 14px;
      width: 40px;
      height: 40px;
      color: $--color-text-primary;
      box-shadow: 0 0 0 1.5px #202945 inset;
      border-radius: 50px;
      cursor: pointer;
    }
    .query-filter {
      padding: 0;
      .select-date {
        .el-input__prefix,
        .el-date-editor .el-range__icon {
          color: $--color-primary;
          font-size: 18px;
          margin-right: 8px;
        }
        input {
          font-weight: bold;
        }
        .el-input .el-input__inner {
          cursor: pointer;
          height: 48px;
          line-height: 48px;
          padding-left: 34px;
          font-weight: bold;
          color: $--color-text-primary;
          text-align: center;
        }
        .el-input__icon :after {
          font-family: 'icon' !important;
          content: '\E7F8';
          font-size: 22px;
          color: $--color-warning;
          margin-bottom: 2px;
        }
        // .el-range__close-icon.el-input__icon:after {
        //   font-family: 'icon' !important;
        //   content: '\E7F8';
        //   font-size: 22px;
        //   line-height: 42px;
        //   margin-right: 30px;
        //   color: $--color-warning;
        // }
        .el-input__icon.el-range__icon.el-icon-date {
          color: $--color-primary;
          font-size: 18px;
          margin-top: 2px;
        }
        .el-input .el-input__inner {
          cursor: pointer;
          height: 48px;
          line-height: 48px;
          padding-left: 34px;
          font-weight: bold;
          color: $--color-text-primary;
        }
      }
    }
    .week-picker,
    .season-picker,
    .year-picker {
      display: flex;
      justify-content: space-between;
      .el-input {
        width: 47% !important;
        &:last-of-type {
          float: right;
        }
      }
      // i {
      //   flex: 1;
      //   text-align: center;
      // }
    }

    .season-picker {
      display: flex;
      justify-content: space-between;
      .quarter-picker {
        width: 47% !important;
        .el-input {
          width: 100% !important;
        }
        &:last-of-type {
          float: right;
        }
      }
      // i {
      //   flex: 1;
      //   text-align: center;
      // }
    }

    .search-content {
      overflow: hidden;

      .filter {
        width: 40px;
        height: 40px;
        border-radius: 100%;
        box-shadow: 0 0 0 1.5px #202945 inset;
        line-height: 40px;
        text-align: center;
        .icon {
          font-size: 16px;
          color: #202945;
        }
      }
    }
  }

  .table-bd {
    height: 550px;
  }
  .page-footer {
    height: 88px;
  }
}
</style>
